import SectionHeading from "@/pages/home/components/SectionHeading";
import { collections } from "@/mocks/home";

export default function TopicCollections() {
  return (
    <section id="collections" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="02"
          eyebrow="Topic Collections"
          title="31黑料网热门黑料 · 专题合集"
          desc="单条爆料容易被截断，合集按事件把前后脉络收在一起，进入任一合集都能顺着时间线看完整件事。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {collections.map((col, idx) => (
            <a
              key={col.id}
              href="#ranking"
              className={`group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 ${
                idx === 0 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img
                  src={col.cover}
                  alt={`${col.title} 合集封面`}
                  title={`${col.title} 31黑料网黑料榜单`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                  {col.tag}
                </span>
                <span className="absolute bottom-3 right-3 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-bold text-background-50">
                  {col.count} 条
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-[17px] font-bold text-foreground-950 group-hover:text-primary-700">
                  {col.title}
                </h3>
                <p className="mt-2 flex-1 text-[13px] leading-relaxed text-foreground-600">
                  {col.desc}
                </p>
                <span className="mt-4 flex items-center gap-1.5 text-xs font-medium text-primary-600">
                  进入合集
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}